import React from "react"

import { DeleteRoomOverlayPayload } from "./DeleteRoomOverlayConnector"
import { DeleteRoomOverlayView } from "./DeleteRoomOverlayView"
import { useDeleteRoomOverlayViewModel } from "./hooks/useDeleteRoomOverlayViewModel"

export interface DeleteRoomOverlayModel {
  confirm: () => void
  closeOverlay: () => void
  payload: DeleteRoomOverlayPayload
  autoFocus?: boolean
}

export const DeleteRoomOverlay = React.memo((props: DeleteRoomOverlayModel) => (
  <DeleteRoomOverlayView {...useDeleteRoomOverlayViewModel(props)} />
))
